import PMBPagination from 'components/PMBPagination'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import { useEffect, useState } from 'react'
import { Calendar, ChevronDown } from 'react-feather'
import { Col } from 'reactstrap'
import Flatpickr from 'react-flatpickr'
import { TableComponent } from 'components/TableComponent'
import { useDispatch, useSelector } from 'react-redux'
import { setFetchOption } from './attendanceSummarySlice'
import { useDebounce } from 'helpers'
import { useNavigate } from 'react-router-dom'
import { URL_ATTENDANCE_INDIVIDUAL } from 'utils/pathUrl'
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
import moment from 'moment-timezone'
import PMBSelect from 'components/PMBSelect'
import { P } from 'components'
import { useLazyFetchFarmersV2Query } from '../farmers-web/farmers-list/farmersListApiSlice'
import LihatDetail from 'components/Icons/LihatDetail'
import { setFetchOption as setFetchOption2 } from '../attendance-report/reportAttendanceSlice'

const TableSummary = ({
  res,
  noDate,
  noSearch,
  selectMember,
  today,
  noDetail,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, tag } = useSelector((s) => s.attendanceSummary)
  const { profile } = useSelector((s) => s.dashboard)
  const [searchInput, setSearchInput] = useState('')
  const [dataMember, setDataMember] = useState([])
  const [dataJoin, setDataJoin] = useState([])

  const [getAnggota] = useLazyFetchFarmersV2Query()

  useEffect(() => {
    const fetchJoinMembers = async () => {
      if (!tag) return
      try {
        const res = await getAnggota({
          size: tag?.size,
          page: tag?.page,
          status: 'JOIN',
        }).unwrap()

        if (res?.totalItems > res?.items?.length) {
          const res2 = await getAnggota({
            size: res?.totalItems,
            status: 'JOIN',
          }).unwrap()

          setDataJoin(res2?.items || [])
        } else {
          setDataJoin(res?.items || [])
        }
      } catch (err) {
        console.error('Error fetching anggota:', err)
      }
    }

    fetchJoinMembers()
  }, [])

  useEffect(() => {
    if (dataJoin) {
      if (!tag?.memberUserId) {
        dispatch(
          setFetchOption({
            memberUserId: dataJoin?.[0]?.userId,
          }),
        )
      }
      const newData = dataJoin?.map((e) => {
        return {
          value: e?.userId,
          label: e?.name,
          ...e,
        }
      })
      setDataMember(newData)
    }
  }, [dataJoin])

  const columns = [
    {
      name: <span>Nama Karyawan</span>,
      sortable: true,
      sortField: 'name',
      cell: (row) => (
        <span data-testid={`attendance-summary-row-${row.id}`}>
          {row?.name}
        </span>
      ),
    },
    {
      name: <span>Total Durasi Kerja</span>,
      sortable: true,
      sortField: 'numHours',
      right: noDetail ? false : true,
      cell: (row) => {
        return `${Number(row?.numDays) > 0 ? `${row?.numDays} Hari ` : ''}${Number(row?.numHours) > 0 ? `${row?.numHours} Jam ` : ''}${Number(row?.numMinutes) > 0 ? `${row?.numMinutes} Menit` : '-'}`
      },
    },
    ...(noDetail
      ? []
      : [
          {
            name: '',
            right: true,
            cell: (row) => (
              <LihatDetail
                onClick={() => {
                  dispatch(
                    setFetchOption2({
                      from: selectMember ? tag?.from : !today ? tag?.from : '',
                      to: selectMember ? tag?.to : !today ? tag?.to : '',
                    }),
                  )
                  navigate(`${URL_ATTENDANCE_INDIVIDUAL}?id=${row?.userId}`, {
                    state: selectMember
                      ? {
                          noAction: true,
                          name: row?.name,
                          from: tag?.from,
                          to: tag?.to,
                        }
                      : today
                        ? { today: true, name: row?.name }
                        : { name: row?.name, from: tag?.from, to: tag?.to },
                  })
                }}
                id={row?.id}
                data-testid={`attendance-summary-detail-${row?.userId}`}
              />
            ),
          },
        ]),
  ]

  const handleSort = (column, direction) => {
    dispatch(
      setFetchOption({
        sortby: column.sortField,
        sortdir: direction.toUpperCase(),
      }),
    )
  }

  const debouncedSearch = useDebounce((value) => {
    dispatch(
      setFetchOption({
        page: 0,
        s: value,
      }),
    )
  }, 600)

  const onHandleSearchChange = (value) => {
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' && tag?.s.length === 0) {
      e.preventDefault()
    }
  }

  return (
    <TableComponent
      columns={columns}
      data={res?.data?.items}
      progressPending={res?.status === 'pending' || loading}
      sortServer
      defaultSortFieldId={1}
      defaultSortAsc={false}
      sortIcon={<ChevronDown />}
      onSort={handleSort}
      pagination
      paginationServer
      paginationComponent={(props) => (
        <PMBPagination
          rowCount={res?.data?.totalItems || 0}
          currentPage={tag?.page}
          rowsPerPage={tag?.size}
          setCurrentPage={(e) => {
            dispatch(setFetchOption({ page: e }))
          }}
          setRowsPerPage={(e) => {
            dispatch(setFetchOption({ size: e }))
          }}
          testId="attendance-summary-pagination"
        />
      )}
      subHeader={!noSearch || !noDate || selectMember}
      subHeaderComponent={
        <div className="w-100 d-flex flex-wrap flex-md-row flex-column">
          {/* Selction permember */}
          {selectMember && (
            <Col xs={12} md={4} lg={3} className="mb-3 me-md-3">
              <P className="mb-2">Pilih Anggota</P>
              <PMBSelect
                value={dataMember?.find((e) => e?.userId === tag?.memberUserId)}
                onChange={(e) => {
                  dispatch(
                    setFetchOption({
                      memberUserId: e?.value,
                    }),
                  )
                }}
                options={dataMember}
                isMulti={false}
                testId="attendance-summary-member-filter"
                // loading={isLoadingJoin}
              />
            </Col>
          )}

          {/* Cari */}
          {!noSearch && (
            <Col xs={12} md={4} lg={3} className="mb-3 me-md-3">
              <PMBSearchInputGroup
                label={'Cari'}
                value={searchInput}
                placeholder="Cari..."
                onChange={(e) => onHandleSearchChange(e.target.value)}
                maxWidth="100%"
                onKeyDown={handleKeyDown}
                testId="attendance-summary-search-input"
              />
            </Col>
          )}

          {/* Tanggal */}
          {!noDate && (
            <Col xs={12} md={4} lg={3} className="mb-3 me-md-3">
              <p className="mb-1">Bulan</p>
              <div
                className="d-flex align-items-center justify-content-center border rounded pointer"
                style={{
                  padding: '2px 6px',
                }}
              >
                <Calendar size={17} className="ms-3" />
                <Flatpickr
                  value={
                    tag?.from
                      ? moment(tag?.from).format('YYYY-MM')
                      : moment().format('YYYY-MM')
                  }
                  onChange={(dates) => {
                    const startOfMonth = moment(dates[0])
                      .startOf('month')
                      .toISOString()
                    const endOfMonth = moment(dates[0])
                      .endOf('month')
                      .toISOString()

                    dispatch(
                      setFetchOption({
                        from: startOfMonth,
                        to: endOfMonth,
                      }),
                    )
                  }}
                  options={{
                    altInput: true,
                    altFormat: 'F Y',
                    dateFormat: 'Y-m',
                    defaultDate: tag?.from
                      ? moment(tag?.from).format('YYYY-MM')
                      : moment().format('YYYY-MM'),
                    disableMobile: true,
                    maxDate: moment().format('YYYY-MM'),
                    minDate: profile?.createdAt
                      ? moment(profile.createdAt).format('YYYY-MM-DD')
                      : undefined,
                    plugins: [
                      new MonthSelectPlugin({
                        shorthand: false,
                        dateFormat: 'Y-m',
                        altFormat: 'F Y',
                      }),
                    ],
                  }}
                  className="form-control bg-transparent border-0 shadow-none pointer"
                  data-testid="attendance-summary-month-filter"
                />
              </div>
            </Col>
          )}
        </div>
      }
    />
  )
}

export default TableSummary
